import axios, { isAxiosError } from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { PurchaseSubscription } from '@app-types/subscription.type';

const BASE_URL = process.env.REACT_APP_SUBSCRIPTIONS_URL as string;

type Response = {
    created: boolean;
    error?: string;
};

const createAdminSubscription = async (
    req: PurchaseSubscription
): Promise<Response> => {
    try {
        const url = buildEndpoint(BASE_URL, 'api/admin/subscriptions');
        console.log(url.toString());
        const response = await axios.post(url.toString(), req, {
            headers: { Authorization: getAuthToken() },
        });
        console.log('created sub:', response.data);
        return { created: true };
    } catch (err) {
        console.error('Error creating admin subscription:', err);
        let message = 'Ocurrió un error inesperado';
        if (isAxiosError(err) && err.response) {
            message = mapStatusCode(err.response.status);
        }
        return { created: false, error: message };
    }
};

const mapStatusCode = (status: number) => {
    switch (status) {
        case 422:
        case 400:
            return 'Datos inválidos. Revísalos nuevamente.';
        case 401:
        case 403:
            return 'No tienes autorización para realizar esta operación';
        case 409:
            return 'El usuario ya posee una suscripción activa';
        case 500:
        default:
            return 'Error interno';
    }
};

export { createAdminSubscription };
